
	import iconfont from '../components/iconfont.vue';
	import {
		ElMessage,
		ElMessageBox
	} from 'element-plus'
	export default {
		data() {
			return {
				clientWidth: document.documentElement.clientWidth,
				clientHeight: document.documentElement.clientHeight,
				keyword: "",
				isloading: false,
				edtdirect: 'rtl',
				editopinfo: false,
				editortitle: this.PAGELANG.ziliaobianji,
				curselname: "tab0",
				ptreeselids: [],
				permittree: [],
				props: {
					label: 'PermitName',
					children: 'LHSTChildren',
					disabled: this.disableFunc
				},
				edtrole: {
					ID: 0,
					Role: '',
					Brief: '',
					Status: true,
				},
				rule: {
					Role: [{
						required: true,
						message: this.PAGELANG.qtxjsmc,
						trigger: 'blur'
					}]
				},
				tabledata: [],
			}
		},
		watch: {
			clientWidth(val) {
				// 为了避免频繁触发resize函数导致页面卡顿，使用定时器
				if (!this.timerw) {
					// 一旦监听到的clientWidth值改变，就将其重新赋给data里的clientWidth
					this.clientWidth = val
					this.timerw = true
					let that = this
					setTimeout(function() {
						that.timerw = false
					}, 400)
				}
			},
			clientHeight(val) {
				if (!this.timerh) {
					// 一旦监听到的clientHeight值改变，就将其重新赋给data里的clientHeight
					this.clientHeight = val
					this.timerh = true
					let that = this
					setTimeout(function() {
						that.timerh = false;
					}, 400)
				}
			}
		},
		beforeCreate() {
			this.PAGELANG = this.LANG.pages.Role;
		},
		methods: {
			onEdtTabClicked(evt) {
				console.log(evt);
				//if(evt.paneName == 'tab2') {
				//	this.RefreshPermits();
				//}
			},
			disableFunc() {
				if(this.edtrole.RoleID == '5')
					return true;
				else 
					return false;
			},
			handleCheckChange(data, checked, indeterminate) {
				console.log(data, checked, indeterminate);
				if (checked) {
					if(this.ptreeselids.indexOf(data.ID) < 0)
						this.ptreeselids.push(data.ID);
				}
				else if (this.ptreeselids.indexOf(data.ID) >= 0)
					this.ptreeselids.splice(this.ptreeselids.indexOf(data.ID), 1);
				console.log(this.ptreeselids);
			},
			SaveRole() {
				if(this.LoadingPermit) {
					ElMessage({
						message: this.PAGELANG.zzclsjqsh,
						type: "warning"
					})
				}

				let postdata = {
					ptreeselids: this.ptreeselids
				}
				
				for(var key in this.edtrole) {
					postdata[key] = this.edtrole[key];
				}
				
				//console.log(postdata);

				this.axios.post(this.actions.saverole, postdata).then((response) => {
					console.log(response.data);
					if (response.data == "OK") {
						this.$message.success(this.PAGELANG.caozuochenggong);
						this.$router.go(0);
					}
				})
			},
			handleResize() {
				this.clientWidth = document.documentElement.clientWidth;
				this.clientHeight = document.documentElement.clientHeight;
			},
			CloseDrawer() {
				this.editopinfo = false;
			},
			Delete(delid) {
				console.log(delid);
				ElMessageBox.confirm(this.PAGELANG.nqdyscgjsm, {
						type: 'warning'
					})
					.then(() => {
						this.axios.get(this.actions.delrole, {
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded'
							},
							params: {
								"id": delid
							}
						}).then((response) => {
							console.log(response.data);
							if (response.data == "OK") {
								this.$message.success(this.PAGELANG.qxzygjs);
								this.$router.go(0);
							}
						})
					})
					.catch((err) => {
						// catch error
						console.log(err);
					})
			},
			Refresh() {
				this.GetRoleList();
			},
			GoBack() {
				this.$router.go(-1);
			},
			Search() {
				this.Refresh();
			},
			CreateRole() {
				//先初始化
				this.edtrole = {
					ID: 0,
					Role: '',
					Brief: '',
					Status: true,
				}
				this.shouldreadonly = false;
				this.editopinfo = true;
				this.curselname = "tab0";
				this.oprolelst = [];
				this.ptreeselids = [];
				
				this.axios.get(this.actions.oprolepermits, {
					headers: {
						"Content-Type": "application/json",
					},
					params: {
					}
				}).then((response) => {
					console.log(response.data);
					this.isloading = false;
					this.oprolelist = response.data.oprolelist;
					
					this.permittree = response.data.permittree;

					this.editopinfo = true;
					
					//this.RefreshPermits();
				});
			},
			formatDate(date) {
				var datetime = new Date(date * 1000);
				var year = datetime.getFullYear();
				var month = ("0" + (datetime.getMonth() + 1)).slice(-2);
				var day = ("0" + datetime.getDate()).slice(-2);
				var hour = ("0" + datetime.getHours()).slice(-2);
				var minute = ("0" + datetime.getMinutes()).slice(-2);
				var second = ("0" + datetime.getSeconds()).slice(-2);
				return year + "-" + month + "-" + day + ' ' + hour + ':' + minute + ':' + second;
			},
			GetRoleList() {
				this.isloading = true;
				this.axios.get(this.actions.rolelist, {
					headers: {
						"Content-Type": "application/json",
					},
				}).then((response) => {
					this.isloading = false;
					console.log(response.data);
					this.tabledata = response.data;
				});
			},
			Edit(id) {
				if (!id) {
					return false;
				}
				
				this.EditingRoleID = id;

				this.isloading = true;

				this.axios.get(this.actions.editrole, {
					headers: {
						"Content-Type": "application/json",
					},
					params: {
						id: id,
					}
				}).then((response) => {
					console.log(response.data);
					this.isloading = false;
					this.editortitle = this.PAGELANG.ziliaobianji + ' - ' + response.data.role.Role;
					this.edtrole = response.data.role;
					this.edtrole.Status = (this.edtrole.Status == 1 ? true : false);
					
					//console.log(this.ptreeselids)

					this.shouldreadonly = true;
					this.editopinfo = true;
					
					this.RefreshPermits(id);
				});
			},
			RefreshPermits(id) {
				this.permittree = [];
				this.ptreeselids = [];
				this.LoadingPermit = true;
				if(!id)
					id = this.EditingRoleID;
					
				this.axios.post(this.actions.rolepermits, {
						id: id,
						oprolelst: this.oprolelst
					}, {
					headers: {
						"Content-Type": "application/json",
					} 
				}).then((response) => {
					this.LoadingPermit = false;
					console.log(response.data);
					this.permittree = response.data.permittree;
					this.ptreeselids = response.data.ptreeselids;
					
					if(this.$refs.permittree)
						this.$refs.permittree.setCheckedKeys(this.ptreeselids);
				});
			},
			UpdateStatus(id, status) {
				//console.log(id);
				if (!id) {
					return;
				}

				this.axios.get(this.actions.updatestatus, {
					headers: {
						"Content-Type": "application/json",
					},
					params: {
						id: id,
						status: status,
					}
				}).then((response) => {
					console.log(response.data);
					if (response.data == "OK") {
						this.$message.success("操作成功");
					}
				})
			}
		},
		created: function() {
			window.addEventListener('resize', this.handleResize)
			this.Refresh();
		},
		components: {
			iconfont
		}
	}
